/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kiotviet_Unlinked_No_PermissionInputs */

const vi_kiotviet_unlinked_no_permission = /** @type {(inputs: Kiotviet_Unlinked_No_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn chưa có quyền nối sản phẩm (cần quyền Cập nhật sản phẩm). Vui lòng báo quản lý để nối trước khi xuất kho.`)
};

/**

* @param {Kiotviet_Unlinked_No_PermissionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const kiotviet_unlinked_no_permission = /** @type {((inputs?: Kiotviet_Unlinked_No_PermissionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kiotviet_Unlinked_No_PermissionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_kiotviet_unlinked_no_permission(inputs)
});